import { StepBase } from './StepBase'
import { PageStepType } from './PageTypes';
import { StringOptions } from '../utils/StringOptions';
import { LogicEngine } from '../LogicEngine/LogicEngine';
import { DataQuery } from '../utils/DataQuery';
import { DataRecord } from '../utils/DataRecord';
import { DataServices } from '../utils/DataServices';
import { DataDictionary } from '../utils/DataDictionary';
import { DataDictionaryTable } from '../utils/DataDictionary';

export class StepList extends StepBase
{
    logicRef    : LogicEngine | undefined;
    records     : DataRecord[] = [];
    listOptions : { [keyName : string ] : string } = {};

    // track the current row number being executed
    rowNum      : number = 0;

    /** Add a column to the list of tabs we're tracking in this holder */
    async addOption(step : PageStepType)
    {
        if (!this.logicRef)
            throw "Exception: should not happen but logicRef in StepTabs is null";

        // Key is the configuration lookup key
        let key = step.step_option ? step.step_option : "";
        key = key.toLowerCase().trim();

        // Value from the text_en column
        let value = step.option_1 ? this.logicRef.processTextReplacement(step.option_1) : "";

        this.listOptions[key] = value;
    }

    /**
     *  Process the data type here.
     *  Load the data related to the Query data type.
     */
    async processStep(logic : LogicEngine) : Promise<boolean>
    {
        this.logicRef = logic;
        await super.processStep(logic);

        this.rowNum = 0;
        this.logicRef?.assign("current_row_number", this.rowNum);

        if (this.options.checkOption("Query"))
        {
            this.records = await DataQuery.instance().executeQueryByText(this.text);
            // console.log("StepList processStep QUERY=", this.text);
            // console.log("StepList processStep FOUND=", this.records.length);
        } else {
            throw "processStep unknown option, expecting query";
        }

        return true;
    }

    /**
     * Return the next record in the list or null if there are no more
     */
    getNextRecord() : DataRecord | null
    {
        if (this.records.length === 0) return null;

        const record = this.records.shift();
        if (record)
        {
            // Brian - Do not import during this loop, leave that to the user of the data
            // this.logicRef?.import(record.data);

            // Next record has a higher row number
            // so in the List output, {{ current_row_number }} starts at 1
            this.rowNum++;
            this.logicRef?.assign("current_row_number", this.rowNum);

            return record;
        }

        return null;
    }

    async processEndList(step : PageStepType) : Promise<void>
    {
    }
}
